const css = `.signature-input .signature-section {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.signature-input .signature-section .signature-pad-container {
  border: 1px solid var(--border-strong);
  border-radius: 4px;
  background-color: var(--paper);
}
.signature-input .signature-section .signature-pad-container:has(.signature-image) {
  border-color: transparent;
}
.signature-input .signature-section .signature-pad-container .signature-pad {
  width: 100%;
  height: 200px;
  filter: var(--ink-filter);
}
.signature-input .signature-section .signature-pad-container .signature-image {
  height: 248px;
}
.signature-input .signature-section .signature-actions {
  display: flex;
  gap: 8px;
  justify-content: flex-end;
}
.signature-input .signature-note {
  color: var(--text-muted);
  font-style: italic;
  padding-left: 0;
  min-height: unset;
}
.signature-input.invalid-form-field .signature-pad-container {
  border-color: var(--danger);
}
.signature-input .field-error {
  top: calc(100% - 64px) !important;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiL29wdC9yZW5kZXIvcHJvamVjdC9zcmMvc3JjL2NvbXBvbmVudHMvU2lnbmF0dXJlSW5wdXQiLCJzb3VyY2VzIjpbIlNpZ25hdHVyZUlucHV0LnNjc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQ0U7RUFDRTtFQUNBO0VBQ0E7O0FBRUE7RUFDRTtFQUNBO0VBQ0E7O0FBRUE7RUFDRTs7QUFHRjtFQUNFO0VBQ0E7RUFDQTs7QUFHRjtFQUNFOztBQUlKO0VBQ0U7RUFDQTtFQUNBOztBQUlKO0VBQ0U7RUFDQTtFQUNBO0VBQ0E7O0FBSUE7RUFDRTs7QUFJSjtFQUNFIiwic291cmNlc0NvbnRlbnQiOlsiLnNpZ25hdHVyZS1pbnB1dCB7XG4gIC5zaWduYXR1cmUtc2VjdGlvbiB7XG4gICAgZGlzcGxheTogZmxleDtcbiAgICBmbGV4LWRpcmVjdGlvbjogY29sdW1uO1xuICAgIGdhcDogMTZweDtcblxuICAgIC5zaWduYXR1cmUtcGFkLWNvbnRhaW5lciB7XG4gICAgICBib3JkZXI6IDFweCBzb2xpZCB2YXIoLS1ib3JkZXItc3Ryb25nKTtcbiAgICAgIGJvcmRlci1yYWRpdXM6IDRweDtcbiAgICAgIGJhY2tncm91bmQtY29sb3I6IHZhcigtLXBhcGVyKTtcblxuICAgICAgJjpoYXMoLnNpZ25hdHVyZS1pbWFnZSkge1xuICAgICAgICBib3JkZXItY29sb3I6IHRyYW5zcGFyZW50O1xuICAgICAgfVxuXG4gICAgICAuc2lnbmF0dXJlLXBhZCB7XG4gICAgICAgIHdpZHRoOiAxMDAlO1xuICAgICAgICBoZWlnaHQ6IDIwMHB4O1xuICAgICAgICBmaWx0ZXI6IHZhcigtLWluay1maWx0ZXIpO1xuICAgICAgfVxuXG4gICAgICAuc2lnbmF0dXJlLWltYWdlIHtcbiAgICAgICAgaGVpZ2h0OiAyNDhweDtcbiAgICAgIH1cbiAgICB9XG5cbiAgICAuc2lnbmF0dXJlLWFjdGlvbnMge1xuICAgICAgZGlzcGxheTogZmxleDtcbiAgICAgIGdhcDogOHB4O1xuICAgICAganVzdGlmeS1jb250ZW50OiBmbGV4LWVuZDtcbiAgICB9XG4gIH1cblxuICAuc2lnbmF0dXJlLW5vdGUge1xuICAgIGNvbG9yOiB2YXIoLS10ZXh0LW11dGVkKTtcbiAgICBmb250LXN0eWxlOiBpdGFsaWM7XG4gICAgcGFkZGluZy1sZWZ0OiAwO1xuICAgIG1pbi1oZWlnaHQ6IHVuc2V0O1xuICB9XG5cbiAgJi5pbnZhbGlkLWZvcm0tZmllbGQge1xuICAgIC5zaWduYXR1cmUtcGFkLWNvbnRhaW5lciB7XG4gICAgICBib3JkZXItY29sb3I6IHZhcigtLWRhbmdlcik7XG4gICAgfVxuICB9XG5cbiAgLmZpZWxkLWVycm9yIHtcbiAgICB0b3A6IGNhbGMoMTAwJSAtIDY0cHgpICFpbXBvcnRhbnQ7XG4gIH1cbn1cbiJdfQ== */`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};
